import Init from "./init";
import Pages from "./Pages";
import Event from "./Event";

/**
 *  The main component of the app
 *
 * @returns {JSX.Element}
 */

const App = () => {
    return (
        <>
            <Init />
            <Event />
            <Pages />
        </>
    );
};

export default App;
